import * as CommonTypes from "../types/common.types";
import http from "./http-common";

class AdminServiceClass {
    private token: string | undefined;
    private config: { headers: { Authorization: string | undefined } };
    private super: string = '/superowner'
    private agency: string = '/agency'
    private seller: string = '/seller'
    private admin: string = '/admin'
    private passenger: string = '/passenger'
    private tours: string = '/tours'
    private trips: string = '/trips'
    private guider: string = '/guider'
    private driver: string = '/driver'
    private reservation: string = '/reservation'
    private payment: string = '/payments'
    private zone: string = '/zone'
    private subzone: string = '/subzone'
    private sales: string = '/sales'
    private car: string = '/car'
    private cost: string = '/cost'
    private openai: string = '/openai'
    private passenger_authorizations: string = '/passenger_authorizations'
    private re_traspasos: string = '/re-traspasos'
    private traspass_revisions: string = '/traspass-revisions'
    private bot: string = '/bot'
    private cash: string = '/cash'
    private ally: string = '/ally'

    constructor(token?: string) {
        this.token = token;
        this.config = { headers: { Authorization: `Bearer ${this.token}` } };
    }
    
    setToken(token: string) {
      this.token = token;
      this.config = { headers: { Authorization: `Bearer ${this.token}` } };
    }

    login(data: CommonTypes.DefaultLogin) {
      return http.post(this.super + '/login', data)
    }

    createTour(data: Partial<CommonTypes.Tour>) {
      return http.post(this.tours + '/create', data, this.config)
    }

    createTrip(data: Partial<CommonTypes.Trip>) {
      return http.post(this.trips, data, this.config)
    }

    editTrip(trip_id: string, data: CommonTypes.Trip) {
      return http.put(this.trips + `/editTrip/${trip_id}`, data, this.config)
    }

    deleteTrip(trip_id: string) {
      return http.delete(this.trips + `/delete/${trip_id}`, this.config)
    }

    me() {
      return http.get(this.super + '/me', this.config)
    }

    // tours
    getTour(id: string) {
      return http.get(this.tours + `/tour/${id}`, this.config)
    }

    editTour(data: CommonTypes.EditTour) {
      return http.put(this.tours + `/edit`, data, this.config)
    }

    deleteTour(id: string) {
      return http.delete(this.tours + `/delete/${id}`, this.config)
    }

    getPassengerPlan(id: string) {
      return http.get(this.passenger + `/passenger-plan?passenger_id=${id}`, this.config)
    }

    deleteReservation(id: string) {
      return http.delete(this.reservation + `/delete/${id}`, this.config)
    }

    // traspass

    traspass(data: CommonTypes.TraspassReservations) {
      return http.post(this.reservation + '/traspass', data, this.config)
    }

    listTraspass() {
      return http.get(this.reservation + '/listTraspass', this.config)
    }

    getTraspass(agency_id: string, from?: string, to?: string) {
      const params = new URLSearchParams()
      if (from) params.append('from', from)
      if (to) params.append('to', to)
      const query = params.toString() ? `?${params.toString()}` : ''
      return http.get(this.reservation + `/traspass/${agency_id}${query}`, this.config)
    }

    // agencies 
    createAgency(data: Partial<CommonTypes.Agency>) {
      return http.post(this.agency + '/register', data, this.config)
    }

    editAgency(data: Partial<CommonTypes.Agency>) {
      return http.put(this.agency + '/edit', data, this.config)
    }

    deleteAgency(id: string) {
      return http.delete(this.agency + `/delete/${id}`, this.config)
    }

    editAgencyInfo(data: FormData) {
      return http.put(this.agency + `/edit/info`, data , {...this.config, headers: {...this.config.headers, 'Content-Type': 'multipart/form-data' }})
    }

    agencyMe() {
      return http.get(this.agency + '/me', this.config)
    }

    // sellers
    createSeller(data: Partial<CommonTypes.Seller>) {
      return http.post(this.seller + '/register', data, this.config)
    }

    editSeller(data: Partial<CommonTypes.Seller>) {
      return http.put(this.seller + '/edit', data, this.config)
    }

    deleteSeller(id: string) {
      return http.delete(this.seller + `/delete/${id}`, this.config)
    }

    getSeller(id: string) {
      return http.get(this.seller + `/sellers/${id}`, this.config)
    }

    listSellers() {
      return http.get(this.seller + '/list', this.config)
    }

    helthByDay(seller_id: string, day: Date, endDay?: Date) {
      return http.post(this.seller + '/healthByDay', {seller_id, day, endDay}, this.config)
    }

    // passenger
    createPassenger(data: Partial<CommonTypes.Passenger>) {
      return http.post(this.passenger + '/create', data, this.config)
    }

    editPassenger(data: Partial<CommonTypes.Passenger>) {
      return http.put(this.passenger + '/edit/admin', data, this.config)
    }

    deletePassenger(id: string) {
      return http.delete(this.passenger + `/delete/${id}`, this.config)
    }


    // admins
    createAdmin(data: Partial<CommonTypes.Admin>) {
      return http.post(this.admin + '/register', data, this.config)
    }

    editAdmin(data: Partial<CommonTypes.Admin>) {
      return http.put(this.admin + '/edit', data, this.config)
    }

    deleteAdmin(id: string) {
      return http.delete(this.admin + `/delete/${id}`, this.config)
    }

    // guider
    createGuider(data: Partial<CommonTypes.Guider>) {
      return http.post(this.guider + '/create', data, this.config)
    }

    editGuider(data: Partial<CommonTypes.Guider>) {
      return http.put(this.guider + '/edit', data, this.config)
    }

    deleteGuider(id: string) {
      return http.delete(this.guider + `/delete/${id}`, this.config)
    }

    // driver

    createDriver(data: Partial<CommonTypes.Driver>) {
      return http.post(this.driver + '/create', data, this.config)
    }

    editDriver(data: Partial<CommonTypes.Driver>) {
      return http.put(this.driver + '/edit', data, this.config)
    }

    deleteDriver(id: string) {
      return http.delete(this.driver + `/delete/${id}`, this.config)
    }

    listToursReservationsPassengers(date: Date) {
      return http.post(this.tours + '/listToursReservationsPassengers', {date}, this.config)
    }

    listToursTrips(date: string) {
      return http.post(this.tours + '/listToursTripsPassengers', {date}, this.config)
    }

    // trips
    listEarnings(day: Date, endDay?: Date) {
      return http.post(this.trips + '/list/earnings', {day, endDay}, this.config)
    }

    listToursAssigned(date: string) {
      return http.post(this.tours + '/listToursTripsAssigned', {date}, this.config)
    }
    
    listTripsByDay(date: Date, tour_id: string) {
      return http.post(this.trips + '/listTripsByDay', {date, tour_id}, this.config)
    }

    listTripsByDayTraspass(date: Date, tour_id: string) {
      return http.post(this.trips + '/listTripsByDayTraspass', {date, tour_id}, this.config)
    }

    listTripsByDayReservations(date: Date) {
      return http.post(this.trips + '/listTripsByDayReservations', {date}, this.config)
    }

    updateCosts(costs: CommonTypes.TripCost[], trip_id: string) {
      return http.put(this.trips + '/costs', {costs, trip_id}, this.config)
    }

    addPassengers(trip_id: string, passengers: CommonTypes.Passenger[]) {
      return http.post(this.trips + '/addPassengers', {trip_id, passengers}, this.config)
    }

    // reservations

    updatePassStatus(status: boolean, reservation_id: string) {
      return http.put(this.reservation + '/passStatus', {status, reservation_id}, this.config)
    }

    updateArriveStatus(status: boolean, reservation_id: string) {
      return http.put(this.reservation + '/arriveStatus', {status, reservation_id}, this.config)
    }

    traspassAddPassengers(trip_id: string, agency: string, passengers: CommonTypes.Passenger[]) {
      return http.post(this.trips + '/traspass/addPassengers', {trip_id, agency, passengers}, this.config)
    }

    traspassCreateToken(trip_id: string, agency: string) {
      return http.post(this.trips + '/traspass/createToken', {trip_id, agency}, this.config)
    }

    traspassAddPassengersToken(token_id: string, passengers: CommonTypes.Passenger[]) {
      return http.post(this.trips + '/traspass/addPassengersToken', {token_id, passengers})
    }

    assignTrip(reservation_ids: string[], trip_id: string, traspass_price?: number) {
      return http.post(this.reservation + '/assignTrip', {reservation_ids, trip_id, traspass_price}, this.config)
    }

    unassignTrip(reservation_id: string) {
      return http.put(this.reservation + '/unassignTrip', {reservation_id}, this.config)
    }

    editTraspassAmount(reservation_id: string, traspass_price: number, tickets: number) {
      return http.put(this.reservation + `/editTraspassAmount/${reservation_id}`, {traspass_price, tickets}, this.config)
    }

    // allies
    registerAlly(data: Partial<CommonTypes.Ally>) {
      return http.post(this.ally + '/register', data, this.config)
    }

    listAllies() {
      return http.get(this.ally + '/list', this.config)
    }

    getAlly(ally_id: string) {
      return http.get(this.ally + `/allies/${ally_id}`, this.config)
    }

    helthByDayAlly(ally_id: string, day: Date, endDay?: Date) {
      return http.post(this.ally + '/healthByDay', {ally_id, day, endDay}, this.config)
    }

    handleTourPriceChange(ally_id: string, tour_id: string, price: number) {
      return http.post(this.ally + '/handleTourPriceChange', {ally_id, tour_id, price}, this.config)
    }

    // sales 
    listSales(seller_id: string) {
      return http.post(this.seller + '/listSales', {seller_id}, this.config)
    }

    updateSales(authorized: boolean, amount: number, sale_id: string) {
      return http.put(this.seller + '/updateSales', {authorized, amount, sale_id}, this.config)
    }

    deleteSale(sale_id: string) {
      return http.delete(this.seller + `/deleteSale/${sale_id}`, this.config)
    }

    listSalesByDay(start_date: Date, seller_id?: string, ally_id?: string, end_date?: Date) {
      return http.post(this.sales + '/list-per-day', { start_date, seller_id, end_date, ally_id }, this.config)
    }

    getTrip(trip_id: string) {
      return http.get(this.trips + `/trip?trip_id=${trip_id}`, this.config)
    }

    closeTrip(trip_id: string) {
      return http.put(this.trips + '/close', { trip_id }, this.config)
    }

    listAdmins() {
      return http.get(this.admin + '/list', this.config)
    }

    listAgencies() {
      return http.get(this.agency + '/list', this.config)
    }

    listTours() {
      return http.get(this.tours, this.config)
    }

    listPassengers() {
      return http.get(this.passenger, this.config)
    }

    listGuiders() {
      return http.get(this.guider, this.config)
    }

    listDrivers() {
      return http.get(this.driver, this.config)
    }

    // reservations

    getReservation(reservation_id: string) {
      return http.get(this.reservation + `/reservation/${reservation_id}`, this.config)
    }

    editReservation(reservation_id: string, data: CommonTypes.Reservation) {
      return http.put(this.reservation + `/edit/${reservation_id}`, data, this.config)
    }

    editPassengerReservation(reservation_id: string, data: Partial<CommonTypes.ReservationPassenger>) {
      return http.put(this.reservation + `/editPassenger/${reservation_id}`, data, this.config)
    }

    // payments
    registerPayment(data: FormData) {
      return http.post(this.payment + '/add', data, {...this.config, headers: {...this.config.headers, 'Content-Type': 'multipart/form-data' }})
    }

    registerReservationPayment(data: FormData) {
      return http.post(this.payment + '/add-reservation', data, {...this.config, headers: {...this.config.headers, 'Content-Type': 'multipart/form-data' }})
    }

    listPayments(agency_id: string, day: Date, endDay?: Date) {
      return http.post(this.payment + '/list', {agency_id, day, endDay}, this.config)
    }

    deletePayment(payment_id: string) {
      return http.delete(this.payment + `/delete/${payment_id}`, this.config)
    }

    editPayment(payment_id: string, data: FormData) {
      return http.put(this.payment + `/edit/${payment_id}`, data, {...this.config, headers: {...this.config.headers, 'Content-Type': 'multipart/form-data' }})
    }

    createReservationPayment(data: FormData) {
      return http.post(this.payment + '/create-reservation-payment', data, {...this.config, headers: {...this.config.headers, 'Content-Type': 'multipart/form-data' }})
    }

    listReservationPayments(reservation_id: string) {
      return http.get(this.payment + `/list-reservation-payments/${reservation_id}`, this.config)
    }

    listGroupPayments(group_id: string) {
      return http.get(this.payment + `/list-group-payments/${group_id}`, this.config)
    }

    editReservationPayment(payment_reservation_id: string, data: FormData) {
      return http.put(this.payment + `/edit-reservation-payment/${payment_reservation_id}`, data, {...this.config, headers: {...this.config.headers, 'Content-Type': 'multipart/form-data' }})
    }

    deleteReservationPayment(payment_reservation_id: string) {
      return http.delete(this.payment + `/delete-reservation-payment/${payment_reservation_id}`, this.config)
    }

    authorizeReservationPayment(payment_reservation_id: string) {
      return http.put(this.payment + `/authorize-reservation-payment/${payment_reservation_id}`, {}, this.config)
    }

    // tour info

    getTourInfo(data: Partial<CommonTypes.TourInfo>) {
      return http.post(this.tours + '/info', data, this.config)
    }
    
    handleTourInfo(data: FormData) {
      return http.put(this.tours + '/handle/info', data, {...this.config, headers: {...this.config.headers, 'Content-Type': 'multipart/form-data' }})
    }
    
    // blogs

    postBlog(data: FormData) {
      return http.post(this.tours + '/blog', data, {...this.config, headers: {...this.config.headers, 'Content-Type': 'multipart/form-data' }})
    }

    editBlog(data: FormData) {
      return http.put(this.tours + '/blog', data, {...this.config, headers: {...this.config.headers, 'Content-Type': 'multipart/form-data' }})
    }

    listBlogsTour(tour_id: string) {
      return http.get(this.tours + `/blog/${tour_id}`, this.config)
    }
    
    deleteBlog(blog_id: string) {
      return http.delete(this.tours + `/blog/${blog_id}`, this.config)
    }

    // zones
    registerZone(data: FormData) {
      return http.post(this.zone + '/register', data, {...this.config, headers: {...this.config.headers, 'Content-Type': 'multipart/form-data' }})
    }

    editZone(data: FormData) {
      return http.put(this.zone + '/edit', data, {...this.config, headers: {...this.config.headers, 'Content-Type': 'multipart/form-data' }})
    }

    deleteZone(id: string) {
      return http.delete(this.zone + `/delete/${id}`, this.config)
    }

    listZones() {
      return http.get(this.zone + '/list', this.config)
    }

    assignZone(tour_id: string, zone_id: string) {
      return http.post(this.zone + '/assign', { tour_id, zone_id }, this.config)
    }

    // subzones
    registerSubzone(data: FormData) {
      return http.post(this.subzone + '/register', data, {...this.config, headers: {...this.config.headers, 'Content-Type': 'multipart/form-data' }})
    }

    editSubzone(data: FormData) {
      return http.put(this.subzone + '/edit', data, {...this.config, headers: {...this.config.headers, 'Content-Type': 'multipart/form-data' }})
    }

    deleteSubzone(id: string) {
      return http.delete(this.subzone + `/delete/${id}`, this.config)
    }

    listSubzones(zone_id?: string) {
      const q = zone_id ? `?zone_id=${encodeURIComponent(zone_id)}` : ''
      return http.get(this.subzone + '/list' + q, this.config)
    }

    assignSubzone(tour_id: string, subzone_id: string) {
      return http.post(this.subzone + '/assign', { tour_id, subzone_id }, this.config)
    }

    // cars
    registerCar(data: Partial<CommonTypes.Car>) {
      return http.post(this.car + '/register', data, this.config)
    }

    listCars() {
      return http.get(this.car + '/list', this.config)
    }

    editCar(data: Partial<CommonTypes.Car>) {
      return http.put(this.car + '/edit', data, this.config)
    }

    deleteCar(id: string) {
      return http.delete(this.car + `/delete/${id}`, this.config)
    }

    // costs
    listCosts() {
      return http.get(this.cost + '/', this.config)
    }

    createCost(data: Partial<CommonTypes.Cost>) {
      return http.post(this.cost + '/', data, this.config)
    }

    editCost(data: Partial<CommonTypes.Cost>) {
      return http.put(this.cost + '/', data, this.config)
    }
    
    deleteCost(id: string) {
      return http.delete(this.cost + `/delete/${id}`, this.config)
    }

    createDailyCost(data: Partial<CommonTypes.DailyCost>) {
      return http.post(this.cost + '/daily', data, this.config)
    }

    listDailyCosts(day: Date) {
      return http.post(this.cost + '/daily/list', { day }, this.config)
    }

    editDailyCost(id: string, data: Partial<CommonTypes.DailyCost>) {
      return http.put(this.cost + `/daily/edit/${id}`, data, this.config)
    }
    
    deleteDailyCost(id: string) {
      return http.delete(this.cost + `/daily/delete/${id}`, this.config)
    }

    getCostsByTripRange(cost: string, day: Date, endDay?: Date) {
      return http.post(this.cost + `/list/cost/trips/${cost}`, {day, endDay}, this.config)
    }

    // cash
    listCashAccounts() {
      return http.get(this.cash + '/accounts', this.config)
    }

    getAccountBalances(from?: Date, to?: Date) {
      return http.get(this.cash + '/accounts/balances', {...this.config, params: { from, to }})
    }

    setAccountOpeningBalance(account_id: string, opening_balance: number, opening_balance_date: Date) {
      return http.put(this.cash + `/accounts/${account_id}/opening-balance`, { opening_balance, opening_balance_date }, this.config)
    }

    searchReservations(q: string) {
      return http.get(this.cash + '/reservations/search', {...this.config, params: { q }})
    }

    getGroupSummary(group_id: string) {
      return http.get(this.cash + `/groups/${group_id}/summary`, this.config)
    }

    searchExistingPayments(q: string) {
      return http.get(this.cash + '/payments/search', {...this.config, params: { q }})
    }

    listCashCategories(flow_type?: CommonTypes.CashFlowType) {
      return http.get(this.cash + '/categories', {...this.config, params: flow_type ? { flow_type } : undefined})
    }

    createCashMovement(data: FormData) {
      return http.post(this.cash + '/movements', data, {...this.config, headers: {...this.config.headers, 'Content-Type': 'multipart/form-data' }})
    }

    listCashMovements(filters: { from?: Date, to?: Date, account_id?: string, movement_type?: CommonTypes.CashFlowType, category_id?: string, shift_id?: string, unassigned_ventas?: boolean }) {
      return http.post(this.cash + '/movements/list', filters, this.config)
    }

    editCashMovement(movement_id: string, data: FormData) {
      return http.put(this.cash + `/movements/${movement_id}`, data, {...this.config, headers: {...this.config.headers, 'Content-Type': 'multipart/form-data' }})
    }

    deleteCashMovement(movement_id: string) {
      return http.delete(this.cash + `/movements/${movement_id}`, this.config)
    }

    resolveUnassignedVenta(movement_id: string, resolved: boolean, note?: string) {
      return http.put(this.cash + `/movements/${movement_id}/resolve-unassigned`, { resolved, note }, this.config)
    }

    listCashMovementTraspassLinks(movement_id: string) {
      return http.get(this.cash + `/movements/${movement_id}/traspass-links`, this.config)
    }

    importBankStatement(account_id: string, source: CommonTypes.BankStatementSource, file: File) {
      const formData = new FormData()
      formData.append('account_id', account_id)
      formData.append('source', source)
      formData.append('file', file)
      return http.post(this.cash + '/bank-statements', formData, {...this.config, headers: {...this.config.headers, 'Content-Type': 'multipart/form-data' }})
    }

    listBankStatementImports() {
      return http.get(this.cash + '/bank-statements', this.config)
    }

    listBankStatementLines(filters: { account_id?: string, status?: CommonTypes.BankLineStatus }) {
      return http.get(this.cash + '/bank-statement-lines', {...this.config, params: filters})
    }

    searchReconciliationCandidates(line_id: string, q?: string) {
      return http.get(this.cash + `/bank-statement-lines/${line_id}/candidates`, {...this.config, params: q ? { q } : undefined})
    }

    assignLineToMovements(line_id: string, movement_ids: string[]) {
      return http.post(this.cash + `/bank-statement-lines/${line_id}/assign`, { movement_ids }, this.config)
    }

    ignoreBankLine(line_id: string) {
      return http.post(this.cash + `/bank-statement-lines/${line_id}/ignore`, {}, this.config)
    }

    unassignBankLine(line_id: string) {
      return http.post(this.cash + `/bank-statement-lines/${line_id}/unassign`, {}, this.config)
    }

    listCashShifts(from: Date | string, to: Date | string) {
      return http.get(this.cash + '/shifts', {...this.config, params: {from, to}})
    }

    upsertCashShift(data: { shift_date: Date | string, period: 'AM' | 'PM' | 'FULL', role: 'seller' | 'admin', seller_id?: string, admin_id?: string, in_agency?: boolean, in_agency_period?: 'AM' | 'PM' | 'FULL' | null }) {
      return http.post(this.cash + '/shifts', data, this.config)
    }

    deleteCashShift(shift_id: string) {
      return http.delete(this.cash + `/shifts/${shift_id}`, this.config)
    }

    createCashPendingPayment(data: { category_id: string, counterpart_name: string, counterpart_seller_id?: string, total_amount: number, notes?: string, sale_ids?: string[], shift_ids?: string[], advance_movement_ids?: string[] }) {
      return http.post(this.cash + '/pending-payments', data, this.config)
    }

    editCashPendingPayment(pending_payment_id: string, data: { category_id?: string, counterpart_name?: string, counterpart_seller_id?: string, total_amount?: number, notes?: string }) {
      return http.put(this.cash + `/pending-payments/${pending_payment_id}`, data, this.config)
    }

    deleteCashPendingPayment(pending_payment_id: string) {
      return http.delete(this.cash + `/pending-payments/${pending_payment_id}`, this.config)
    }

    listCashPendingPayments(status?: 'open' | 'closed', counterpart_seller_id?: string, from?: Date | string, to?: Date | string) {
      return http.get(this.cash + '/pending-payments', {...this.config, params: { status, counterpart_seller_id, from, to }})
    }

    getDaysWorked(seller_id: string, from: Date, to: Date) {
      return http.get(this.cash + `/days-worked/${seller_id}`, {...this.config, params: { from, to }})
    }

    updateShiftDay(shift_id: string, rate_override: number, authorized: boolean) {
      return http.put(this.cash + `/shifts/${shift_id}/day`, { rate_override, authorized }, this.config)
    }

    listTripCostDebts(paid?: boolean, from?: Date | string, to?: Date | string) {
      return http.get(this.cash + '/trip-cost-debts', {...this.config, params: { paid, from, to }})
    }

    listTraspassDebts(agency_id: string, movement_type: CommonTypes.CashFlowType, from?: Date | string, to?: Date | string) {
      return http.get(this.cash + '/traspass-debts', {...this.config, params: { agency_id, movement_type, from, to }})
    }

    listUnsettledCheckpoints(seller_id: string, from: Date | string, to: Date | string) {
      return http.get(this.cash + `/register/unsettled/${seller_id}`, {...this.config, params: { from, to }})
    }

    settleUnsettledCheckpoints(seller_id: string, from: Date | string, to: Date | string) {
      return http.post(this.cash + `/register/unsettled/${seller_id}/settle`, { from, to }, this.config)
    }

    listUnsettledAdvances(seller_id: string, from: Date | string, to: Date | string) {
      return http.get(this.cash + `/advances/unsettled/${seller_id}`, {...this.config, params: { from, to }})
    }

    adminRegisterApertura(shift_date: Date | string, period: 'AM' | 'PM', seller_id: string, counted_amount: number) {
      return http.post(this.cash + '/register/admin/apertura', { shift_date, period, seller_id, counted_amount }, this.config)
    }

    adminRegisterCierre(shift_date: Date | string, period: 'AM' | 'PM', seller_id: string, counted_amount: number) {
      return http.post(this.cash + '/register/admin/cierre', { shift_date, period, seller_id, counted_amount }, this.config)
    }

    getCheckpoint(shift_date: Date | string, period: 'AM' | 'PM', checkpoint_type: 'apertura' | 'cierre') {
      return http.get(this.cash + '/register/admin/checkpoint', {...this.config, params: { shift_date, period, checkpoint_type }})
    }

    correctCheckpoint(shift_date: Date | string, period: 'AM' | 'PM', checkpoint_type: 'apertura' | 'cierre', counted_amount: number) {
      return http.put(this.cash + '/register/admin/checkpoint', { shift_date, period, checkpoint_type, counted_amount }, this.config)
    }

    // openai
    extractPassengerData(inputText: string) {
      return http.post(this.openai + '/extract-passenger', { text: inputText }, this.config)
    }

    // authorizations
    createPassengerAuthorization(data: CommonTypes.PassengerAuthorization) {
      return http.post(this.passenger_authorizations + '/create', data, this.config)
    }

    getPassengerAuthorizations(startDate: Date, endDate?: Date) {
      return http.post(this.passenger_authorizations + '/list', { startDate, endDate }, this.config)
    }

    approvePassengerAuthorization(id: string) {
      return http.post(this.passenger_authorizations + `/approve/${id}`, {}, this.config)
    }
    
    rejectPassengerAuthorization(id: string) {
      return http.post(this.passenger_authorizations + `/reject/${id}`, {}, this.config)
    }

    createReTraspaso(data: {
      passenger_name: string,
      passenger_nationality?: string,
      tour_id: string,
      tour_date: Date,
      origin_agency_id: string,
      dest_agency_id: string,
      traspass_price_in: number,
      tickets_in: number,
      traspass_price_out: number,
      tickets_out: number,
      notes?: string
    }) {
      return http.post(this.re_traspasos + '/create', data, this.config)
    }

    listAllReTraspasos() {
      return http.get(this.re_traspasos + '/list-all', this.config)
    }

    listReTraspasosByAgency(agency_id: string, from?: string, to?: string) {
      const params = new URLSearchParams()
      if (from) params.append('from', from)
      if (to) params.append('to', to)
      const query = params.toString() ? `?${params.toString()}` : ''
      return http.get(this.re_traspasos + `/list/${agency_id}${query}`, this.config)
    }

    deleteReTraspaso(id: string) {
      return http.delete(this.re_traspasos + `/delete/${id}`, this.config)
    }

    listAllPayments(agency_id: string) {
      return http.get(this.payment + `/list-all/${agency_id}`, this.config)
    }

    createRevision(data: {
      reservation_id?: string
      re_traspaso_id?: string
      agency_id: string
      status: string
      ticket_status?: string
      notes?: string
      chat_source?: string
    }) {
      return http.post(this.traspass_revisions + '/create', data, this.config)
    }

    getAccountStatement(agency_id: string, from?: string, to?: string, includeOpening: boolean = true) {
      const params = new URLSearchParams()
      if (from) params.append('from', from)
      if (to) params.append('to', to)
      if (from && !includeOpening) params.append('include_opening', 'false')
      const query = params.toString() ? `?${params.toString()}` : ''
      return http.get(this.traspass_revisions + `/statement/${agency_id}${query}`, this.config)
    }

    // ---- Bot web ----
    getBotSessions(soloPendientes?: boolean) {
      return http.get(this.bot + '/sessions' + (soloPendientes ? '?requiere_humano=true' : ''), this.config)
    }
    getBotConversation(session_id: string) {
      return http.get(this.bot + `/sessions/${session_id}/conversation`, this.config)
    }
    botResponder(session_id: string, mensaje: string, nombre_agente?: string) {
      return http.post(this.bot + `/sessions/${session_id}/responder`, { mensaje, nombre_agente }, this.config)
    }
    botFinalizar(session_id: string, atendida_por?: string, remarks_operativos?: string) {
      return http.post(this.bot + `/sessions/${session_id}/finalizar-intervencion`, { atendida_por, remarks_operativos }, this.config)
    }
    getBotLeads() {
      return http.get(this.bot + '/leads', this.config)
    }
    updateBotLead(id: number, estado: string) {
      return http.put(this.bot + `/leads/${id}`, { estado }, this.config)
    }
    archivarBotSesion(session_id: string) {
      return http.put(this.bot + `/sessions/${session_id}/archivar`, {}, this.config)
    }
    archivarBotLead(id: number) {
      return http.put(this.bot + `/leads/${id}/archivar`, {}, this.config)
    }
    getBotRules() {
      return http.get(this.bot + '/rules', this.config)
    }
    createBotRule(data: { tour_id?: string; titulo?: string; regla_texto: string }) {
      return http.post(this.bot + '/rules', data, this.config)
    }
    updateBotRule(id: number, data: { activa?: boolean; titulo?: string; regla_texto?: string; prioridad?: number }) {
      return http.put(this.bot + `/rules/${id}`, data, this.config)
    }
    getBotPendientes(resueltos?: boolean) {
      return http.get(this.bot + '/pendientes' + (resueltos ? '?resueltos=true' : ''), this.config)
    }
    updateBotPendiente(id: number, data: { resuelto?: boolean; destino?: string }) {
      return http.put(this.bot + `/pendientes/${id}`, data, this.config)
    }
}

const AdminService = new AdminServiceClass()

export default AdminService;